export default __webpack_public_path__ + "static/media/it.73869f99.svg";